import {
  listAnimationPresets,
  type AnimationPresetDefinition,
  type AnimationPresetGroup,
  type AnimationPresetPhase,
} from '../../../animation';

const GROUP_DISPLAY_ORDER: Record<AnimationPresetGroup, number> = {
  fade: 0,
  slide: 1,
  scale: 2,
};

export const ANIMATION_ROLE_LABEL: Record<AnimationPresetPhase, 'Entrance' | 'Exit'> = {
  IN: 'Entrance',
  OUT: 'Exit',
};

export function listPresetsForRole(phase: AnimationPresetPhase): AnimationPresetDefinition[] {
  return listAnimationPresets(phase)
    .slice()
    .sort((left, right) => GROUP_DISPLAY_ORDER[left.group] - GROUP_DISPLAY_ORDER[right.group]);
}
